import { FeatureFlagsMap, MmuAppContext, MmuMainMenuMainEntry, MmuUserRoles } from '@move/core';


export const customerMenuItems = (appContext: string): MmuMainMenuMainEntry[] => {
  return [
    {
      label: 'mainMenu.dashboard',
      link: '/dashboard',
      icon: 'home',
      isExternalLink: appContext !== MmuAppContext.CONTAINER
    },
    {
      label: 'mainMenu.devices',
      link: '/appliances',
      icon: 'dryer',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.deviceList',
          link: '/appliances',
          exactUrlMatch: 'exact',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.programHistory',
          link: '/appliances/program/history',
          exactUrlMatch: 'exact',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.updates',
          link: '/appliances/updates',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          roles: [MmuUserRoles.ADMIN, MmuUserRoles.ENGINEER]
        },
        {
          label: 'mainMenu.devicePairing',
          link: '/appliances/pairing',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          roles: [MmuUserRoles.ADMIN, MmuUserRoles.ENGINEER]
        }
      ]
    },
    /**
     * @deprecated FFLaundryVertical
     */
    {
      label: 'mainMenu.laundry',
      link: '/laundry/terminals',
      icon: 'shirt',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      feature: FeatureFlagsMap.FFLaundryVertical,
      children: [
        {
          label: 'mainMenu.laundryLoadHistory',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          roles: [MmuUserRoles.ADMIN, MmuUserRoles.ENGINEER],
          link: '/laundry/history'
        },
        {
          label: 'mainMenu.laundryTerminalOverview',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/laundry/terminals'
        },
        {
          label: 'mainMenu.laundryTerminalConfigurations',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          roles: [MmuUserRoles.ADMIN],
          link: '/laundry/configurations'
        }
      ]
    },
    /**
     * @deprecated FF_watsonTestUser
     * @deprecated FF_watsonLaundryPlus
     */
    {
      label: 'mainMenu.watson',
      link: '/watson/dashboards',
      icon: 'chart-pie',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.watsonLocationsInsights',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/f84281be-60a4-4e5b-8f32-5bf5a8f0277f',
          feature: 'watsonTestUser',
          hideFeature: FeatureFlagsMap.FFWatsonLaundryPlus
        },
        {
          label: 'mainMenu.watsonMachineInsights',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/47c6c234-3f36-4553-8601-e8fb4b968745',
          feature: 'watsonTestUser',
          hideFeature: FeatureFlagsMap.FFWatsonLaundryPlus
        },
        {
          label: 'mainMenu.watsonBusinessDashboard',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/75896344-22da-4db4-ae49-e735c0e9cb79',
          feature: [FeatureFlagsMap.FFWatsonLaundryPlus, 'watsonTestUser']
        },
        {
          label: 'mainMenu.watsonOperativeCostsDashboard',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/20a86eb4-02ff-47f5-8411-8f2e46b99729',
          feature: [FeatureFlagsMap.FFWatsonLaundryPlus, 'watsonTestUser']
        },
        {
          label: 'mainMenu.watsonConsumptionsDashboard',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/09b4d00c-30e2-400e-9c82-5adaccb44279',
          feature: [FeatureFlagsMap.FFWatsonLaundryPlus, 'watsonTestUser']
        },
        {
          label: 'mainMenu.watsonCostsPerKgDashboard',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/903f6a73-7108-4639-9fe1-7e083e784cff',
          feature: [FeatureFlagsMap.FFWatsonLaundryPlus, 'watsonTestUser']
        },
        {
          label: 'mainMenu.watsonLaundryPerformanceDashboard',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/d22c45a4-f50f-44f1-873d-e47190659070',
          feature: [FeatureFlagsMap.FFWatsonLaundryPlus, 'watsonTestUser']
        },
        {
          label: 'mainMenu.watsonOperationalDashboard',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/dashboards/c3ed419f-0fae-4b4a-8bd0-0c5258470b83',
          feature: [FeatureFlagsMap.FFWatsonLaundryPlus, 'watsonTestUser']
        },
        {
          label: 'mainMenu.watsonSettings',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          link: '/watson/settings'
        }
      ]
    },
    /**
     * @deprecated FFactionsNNG
     */
    {
      label: 'mainMenu.notifications',
      link: '/actions/notifications',
      icon: 'bell',
      feature: FeatureFlagsMap.FFActionsNNG,
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.notificationsOverview',
          link: '/actions/notifications',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        },
        {
          label: 'mainMenu.notificationsSettings',
          link: '/actions/notifications/settings',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          exactUrlMatch: 'exact'
        }
      ]
    },
    {
      label: 'mainMenu.notifications',
      link: '/notifications',
      icon: 'bell',
      hideFeature: FeatureFlagsMap.FFActionsNNG,
      isExternalLink: appContext !== MmuAppContext.CONTAINER
    },
    /**
     * @deprecated FFKleanMenu
     */
    {
      label: 'mainMenu.cleanAtMove',
      link: 'https://cleanplus.miele-move.com/',
      icon: 'soap',
      feature: FeatureFlagsMap.FFKleanMenu,
      tracked: true,
      isExternalLink: true
    },
    {
      label: 'mainMenu.admin',
      link: '/user/admin',
      icon: 'briefcase',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      roles: [MmuUserRoles.ADMIN],
      children: [
        {
          label: 'mainMenu.company',
          link: '/user/admin/organizations',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.userManagement',
          link: '/user/admin/users',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.locations',
          link: '/user/admin/locations',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.consentManagement',
          link: '/user/admin/consents',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.addOns',
          link: '/pages/subscription',
          isExternalLink: appContext !== MmuAppContext.CONTAINER,
          hideFeature: FeatureFlagsMap.FFEntHideAddons
        }
      ]
    },
    /**
     * @deprecated FFpagesHideShop_IE
     */
    {
      label: 'mainMenu.shop',
      link: '/pages/shop',
      hidden: 'pagesHideShop',
      icon: 'shopping-cart',
      isExternalLink: appContext !== MmuAppContext.CONTAINER
    },
    {
      label: 'mainMenu.support',
      link: '/user/support/contact',
      icon: 'life-ring',
      isExternalLink: appContext !== MmuAppContext.CONTAINER,
      children: [
        {
          label: 'mainMenu.contact',
          link: '/user/support/contact',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        },
        {
          label: 'mainMenu.faq',
          link: '/pages/support/faq',
          isExternalLink: appContext !== MmuAppContext.CONTAINER
        }
      ]
    }
  ];
};

